import theme from '@styles/theme';
export default {
  activeFiltersContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: ['0px', '0px', '0px', '0px', '10px']
  },
  activeFilters: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px'
  },
  filterChip: {
    height: '40px',
    display: 'flex',
    padding: '4px 6px 4px 12px',
    alignItems: 'center',
    gap: '8px',
    border: `1px solid ${theme.rawColors.lightGrey300}`,
    background: theme.rawColors.neutralWhite,
    transition: 'border-color 0.3s ease',
    '&:hover': {
      borderColor: theme.rawColors.darkGrey700
    },
    span: {
      color: theme.rawColors.darkGrey700,
      fontFamily: theme.fonts.uniform,
      fontSize: theme.fontSizes.smallText,
      lineHeight: 'normal'
    },
    '.icon': {
      cursor: 'pointer'
    }
  },
  activeFiltersButton: {
    height: 40,
    marginLeft: 'auto'
  }
};